export default "__VITE_ASSET__419ebd29__"